import { render } from "./SearchResultsCard.vue?vue&type=template&id=e4f37794&scoped=true&ts=true"
import script from "./SearchResultsCard.vue?vue&type=script&lang=ts"
export * from "./SearchResultsCard.vue?vue&type=script&lang=ts"

import "./SearchResultsCard.vue?vue&type=style&index=0&id=e4f37794&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src014250190/src/byggesoknaden-support-gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4f37794"]])

export default __exports__